/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Auth/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Check from './Check/index'
import No from './No/index'
import React from 'react'
import ResetPassword from './ResetPassword/index'
import ResetPasswordConfirm from './ResetPasswordConfirm/index'
import ResetPasswordSent from './ResetPasswordSent/index'
import SignIn from './SignIn/index'
import SignOut from './SignOut/index'
import SignUp from './SignUp/index'
import SignUpConfirm from './SignUpConfirm/index'
import SignUpInviteSent from './SignUpInviteSent/index'
import TermsAndConditions from './TermsAndConditions/index'



/** @type {import('Simple/types.js').View} */
export default function Auth({
  children,
  viewPath = "/App/Auth"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Check'}>
<Check
  viewPath={`${viewPath}/Check`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignIn'}>
<SignIn
  viewPath={`${viewPath}/SignIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignUp'}>
<SignUp
  viewPath={`${viewPath}/SignUp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignUpInviteSent'}>
<SignUpInviteSent
  viewPath={`${viewPath}/SignUpInviteSent`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignUpConfirm'}>
<SignUpConfirm
  viewPath={`${viewPath}/SignUpConfirm`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SignOut'}>
<SignOut
  viewPath={`${viewPath}/SignOut`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResetPassword'}>
<ResetPassword
  viewPath={`${viewPath}/ResetPassword`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResetPasswordSent'}>
<ResetPasswordSent
  viewPath={`${viewPath}/ResetPasswordSent`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResetPasswordConfirm'}>
<ResetPasswordConfirm
  viewPath={`${viewPath}/ResetPasswordConfirm`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TermsAndConditions'}>
<TermsAndConditions
  viewPath={`${viewPath}/TermsAndConditions`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}